import type { Shape } from "plotly.js";

export const CENTRED_PLAYHEAD_MARKER_SHAPE: Partial<Shape> = {
  type: "line",
  xref: "paper",
  x0: 0.5,
  x1: 0.5,
  yref: "paper",
  y0: -0.5,
  y1: 1.5,
  line: { color: "#f44336", width: 2 },
};
